import React from "react";
import "./advantage.scss";

const Advantage = () => {
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

  return (
    <>
      <section className="main-stack">
        <div className="custom-container">
          <div className="inner-stack">
            <div className="left-sidestack" style={isIOS ? {paddingBottom: "0"} : {}}>
              <h2>The Rain Protocol Stack</h2>
              <p>
                Discover what makes Rain the most powerful platform for on-chain
                market creation - built for transparency, automation, and
                community participation.
              </p>
              {
                isIOS ? <><img src="\assets\homepage\banner\stackimg.png" class="img-fluid imgguello" /></> : <><video
                src="\assets\stackvideo.webm"
                autoPlay
                muted
                playsInline
                loop
                className="banner-video"
              /></>
              }
              
            </div>
            <div className="fourstackcards">
              <div className="stackcards">
                <img src="\assets\homepage\banner\launch.svg" />
                <div>
                  <h3>From Blueprint to Launch</h3>
                  <h4>Create, deploy and manage  end-to-end prediction market platforms with zero friction.</h4>
                </div>
              </div>
              <div className="stackcards">
                <img src="\assets\homepage\banner\ai.svg" />
                <div>
                  <h3>AI-Powered Resolution</h3>
                  <h4>Leverage integrated AI agents and intelligent oracles for unbiased, automated, and faster market settlement.</h4>
                </div>
              </div>
              <div className="stackcards">
                <img src="\assets\homepage\banner\layer.svg" />
                <div>
                  <h3>Dispute Handling Layer</h3>
                  <h4>A comprehensive, multi-layered dispute and appeal process ensures every outcome is verified and accurate.</h4>
                </div>
              </div>
              <div className="stackcards">
                <img src="\assets\homepage\banner\modules.svg" />
                <div>
                  <h3>Additional Modules</h3>
                  <h4>Utilize specialized components like Shared Liquidity Markets and RNG capabilities to offer diverse and innovative interfaces.</h4>
                </div>
              </div>
              <div className="stackcards">
                <img src="\assets\homepage\banner\integration.svg" />
                <div>
                  <h3>Community Token Integration</h3>
                  <h4>Rain enables communities to use their native tokens as the primary asset for participation.</h4>
                </div>
              </div>

            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Advantage;
